import { DisplayService } from 'services/DisplayService/DisplayService';
import { dcbsDataStore } from './dcbsDataStore';
import { graphQLService } from './graphQLService';

export const displayService = new DisplayService(
    graphQLService,
    dcbsDataStore.getMapper('location')
);
